import { render, staticRenderFns } from "./ReferralsChart.vue?vue&type=template&id=72912bf7&scoped=true"
import script from "./ReferralsChart.vue?vue&type=script&lang=js"
export * from "./ReferralsChart.vue?vue&type=script&lang=js"
import style0 from "./ReferralsChart.vue?vue&type=style&index=0&id=72912bf7&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72912bf7",
  null
  
)

export default component.exports